import RoleAwareComponent from '../auth/RoleAwareComponent'

export default class WithRole extends RoleAwareComponent {
  render () {
    const { children } = this.props

    return this.shouldBeVisible() ? children : null
  }
}
